import * as React from 'react';

/**
 * Krok APP2 bod 4 (bod 25 zadani) — ODCHOD Z ROZPRACOVANEHO FORMULARE.
 *
 * Krok KLIKFIX1 (vada V17) tohle vyresil pro „Novou zakázku": makler vyplnil
 * jmeno klienta a poznamku z hovoru, obnovil stranku a vse bylo pryc BEZ
 * VAROVANI. Totez platilo pro „Novou fakturu" (nic se neuklada, dokud se
 * doklad nevystavi) a pro rozepsany text inzeratu (uklada se az klepnutim).
 *
 * Tohle je ta JEDNA kopie hlidky. Text hlasky urcuje prohlizec (vlastni vetu
 * uz od roku 2016 nikdo nezobrazi), proto se jen vrati `preventDefault` —
 * zadny nas text tu neni a byt nemuze.
 *
 * Hlidka bezi JEN kdyz je co zachranovat (`hasWork`): dialog nad prazdnym
 * formularem je obtezovani, ne ochrana.
 */
export function useLeaveWarning(hasWork: boolean): void {
  React.useEffect(() => {
    if (!hasWork) return undefined;
    const warn = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [hasWork]);
}
